// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — options-cam-poly.styled.classic.js, новая — options-cam-poly.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './options-cam-poly.styled.classic';
import * as cp from './options-cam-poly.styled.cp';

export const Buttons = isCp ? cp.Buttons : classic.Buttons;
export const Content = isCp ? cp.Content : classic.Content;
export const Info = isCp ? cp.Info : classic.Info;
export const Place = isCp ? cp.Place : classic.Place;
export const RectorPlace = isCp ? cp.RectorPlace : classic.RectorPlace;
